import { Box, IconButton } from "@mui/material";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import { AI_FEEDBACK_DISLIKE, AI_FEEDBACLK_LIKE, AMPLITUDE_EVENT_FEEDBACK_CLICKED } from "../../../../models/Constants";
import { isEmpty } from "lodash";
import { deleteMessageFeedback } from "../../../crud/ai.crud";
import displayToast from "../../../../theme/partials/DisplayToast";
import { useFeedbackFormModalContext } from "./AIFeedbackFormModalContainer";
import useAmplitudeTracking from "../../../../helpers/AmplitudeHelper";

const AIMessageFeedbackControls = ({
	messageId = null,
	activeType = null,
}) => {
	const feedbackFormModalContext = useFeedbackFormModalContext();

	const {
		createFeedback,
		setDeleteFeedback,
		isLoading,
		addLoading,
		finishLoading,
	} = feedbackFormModalContext ?? {};

	const { trackEventWithProperties } = useAmplitudeTracking();

	const onFeedback = async (type) => {
		try {
			const isUpdate = !isEmpty(activeType);

			if (type === activeType) { // remove feedback
				addLoading(messageId);

				const response = await deleteMessageFeedback({message_id: messageId});

				if (response.data?.init?.[0]?.status === "error") {
					displayToast("error", response?.data?.init?.[0]);
					return;
				}

				setDeleteFeedback(messageId);
				displayToast("success", "Feedback removed successfully.");
				
				finishLoading(messageId, -1);
				return;
			}
			
			trackEventWithProperties(AMPLITUDE_EVENT_FEEDBACK_CLICKED, { 
				feedback_type: type === AI_FEEDBACLK_LIKE ? 'thumbs_up' : 'thumbs_down', message_id: messageId,
				message_id: messageId,
			});

			createFeedback(type, messageId, isUpdate);
		} catch (error) {
			console.error("Error handling feedback:", error);
			finishLoading(messageId, -1);
		}
	}

	if (isEmpty(feedbackFormModalContext)) {
		return null;
	}

	return (
		<Box
			sx={{
				...(isLoading(messageId) && {
					pointerEvents: 'none',
					'& .MuiSvgIcon-root': {
						color: 'var(--theme-secondary)', // Default color for both buttons
					},
				}),
			}}
		>
			<IconButton title="Like" onClick={() => onFeedback(AI_FEEDBACLK_LIKE)}>
				<ThumbUpAltIcon color={activeType === AI_FEEDBACLK_LIKE ? "primary" : "var(--theme-septenary)"} />
			</IconButton>
			<IconButton title="Dislike" onClick={() => onFeedback(AI_FEEDBACK_DISLIKE)}>
				<ThumbDownAltIcon color={activeType === AI_FEEDBACK_DISLIKE ? "primary" : "var(--theme-septenary)"} />
			</IconButton>
		</Box>
	);
}

export default AIMessageFeedbackControls;